import React, { useRef, useMemo, useEffect } from 'react';
import { observer } from 'mobx-react';
import { getSnapshot, isStateTreeNode } from 'mobx-state-tree';
import Layout from '../layout';
const BoxTrackBlock = observer(function ({ track, model, offsetX, }) {
    const { blockSize, colWidth, blanks, rowHeight, highResScaleFactor, fontSize, scrollX, } = model;
    const { height, features, associatedRowName } = track.model;
    const feats = isStateTreeNode(features)
        ? // @ts-expect-error
            getSnapshot(features)
        : features;
    const layout = useMemo(() => {
        const temp = new Layout();
        feats === null || feats === void 0 ? void 0 : feats.forEach((feature, index) => {
            const { start, end } = feature;
            if (associatedRowName) {
                const s = model.rowSpecificBpToPx(associatedRowName, start - 1);
                const e = model.rowSpecificBpToPx(associatedRowName, end);
                temp.addRect(`${index}`, s, e, rowHeight, feature);
            }
            else {
                const s = model.globalBpToPx(start - 1);
                const e = model.globalBpToPx(end);
                temp.addRect(`${index}`, s, e, rowHeight, feature);
            }
        });
        return temp;
        // might convert to autorun based drawing
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowHeight, feats, associatedRowName, model, blanks]);
    const ref = useRef(null);
    const labelRef = useRef(null);
    const mouseoverRef = useRef(null);
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const ctx = ref.current.getContext('2d');
        if (!ctx) {
            return;
        }
        ctx.resetTransform();
        ctx.scale(highResScaleFactor, highResScaleFactor);
        ctx.clearRect(0, 0, blockSize, height);
        ctx.translate(-offsetX, 0);
        ctx.textAlign = 'center';
        ctx.font = ctx.font.replace(/\d+px/, `${fontSize}px`);
        const xStart = Math.max(0, Math.floor(offsetX / colWidth));
        ctx.fillStyle = 'goldenrod';
        layout.rectangles.forEach(value => {
            const { minX, maxX, minY, maxY } = value;
            const x1 = (minX - xStart) * colWidth + offsetX - (offsetX % colWidth);
            const x2 = (maxX - xStart) * colWidth + offsetX - (offsetX % colWidth);
            if (x2 - x1 > 0) {
                ctx.fillRect(x1, minY, x2 - x1, (maxY - minY) / 2);
            }
        });
    }, [
        associatedRowName,
        fontSize,
        blockSize,
        colWidth,
        layout.rectangles,
        model,
        rowHeight,
        height,
        offsetX,
        highResScaleFactor,
        features,
        blanks,
    ]);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!labelRef.current) {
            return;
        }
        const ctx = labelRef.current.getContext('2d');
        if (!ctx) {
            return;
        }
        // this logic is very similar to MSACanvas
        ctx.resetTransform();
        ctx.scale(highResScaleFactor, highResScaleFactor);
        ctx.clearRect(0, 0, blockSize, height);
        ctx.translate(-offsetX, 0);
        ctx.textAlign = 'center';
        ctx.font = ctx.font.replace(/\d+px/, `${Math.max(8, rowHeight - 8)}px`);
        ctx.fillStyle = 'black';
        ctx.textAlign = 'left';
        for (const value of layout.rectangles.values()) {
            const { minX, maxX, maxY, minY, data } = value;
            const x1 = minX * colWidth;
            const x2 = maxX * colWidth;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const feature = data;
            if (x2 - x1 > 0) {
                const note = (_b = (_a = feature.attributes) === null || _a === void 0 ? void 0 : _a.Note) === null || _b === void 0 ? void 0 : _b[0];
                const name = (_d = (_c = feature.attributes) === null || _c === void 0 ? void 0 : _c.Name) === null || _d === void 0 ? void 0 : _d[0];
                const type = feature.type;
                ctx.fillText([type, name, note].filter(f => !!f).join(' - '), Math.max(Math.min(-scrollX, x2), x1), minY + (maxY - minY));
            }
        }
    }, [
        blockSize,
        colWidth,
        scrollX,
        highResScaleFactor,
        height,
        layout.rectangles,
        offsetX,
        features,
        model,
        rowHeight,
        blanks,
    ]);
    return !features ? null : (React.createElement(React.Fragment, null,
        React.createElement("canvas", { ref: ref, height: height * highResScaleFactor, width: blockSize * highResScaleFactor, style: {
                position: 'absolute',
                left: scrollX + offsetX,
                width: blockSize,
                height,
            } }),
        React.createElement("canvas", { ref: labelRef, height: height * highResScaleFactor, width: blockSize * highResScaleFactor, style: {
                position: 'absolute',
                left: scrollX + offsetX,
                width: blockSize,
                height,
            } }),
        React.createElement("canvas", { ref: mouseoverRef, height: height * highResScaleFactor, width: blockSize * highResScaleFactor, style: {
                position: 'absolute',
                left: scrollX + offsetX,
                width: blockSize,
                height,
            } })));
});
export default BoxTrackBlock;
//# sourceMappingURL=BoxTrackBlock.js.map